import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

// Import all translation files
import translationEnglish from './assets/translation/english-translation.json'
import translationTraditionalChinese from './assets/translation/traditional-chinese-translation.json'
import translationSimplifiedChinese from './assets/translation/simplified-chinese-translation.json'
import translationJapanese from './assets/translation/japanese-translation.json'

const resources = {
  en: {
    translation: translationEnglish,
  },
  zh: {
    translation: translationTraditionalChinese,
  },
  cn: {
    translation: translationSimplifiedChinese,
  },
  jp: {
    translation: translationJapanese,
  },
}

i18next.use(initReactI18next).init({
  resources,
  lng: 'en',
})

export default i18next
